import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LogsState } from './logs.reducer';

export const selectLogsState = createFeatureSelector<LogsState>('logs');

export const selectAllLogs = createSelector(selectLogsState, (state) => state.logs);

export const selectLogsLoading = createSelector(selectLogsState, (state) => state.loading);

export const selectLogsError = createSelector(selectLogsState, (state) => state.error);

export const selectLogsLastFilter = createSelector(selectLogsState, (state) => state.lastFilter);

export const selectLogsTotal = createSelector(selectLogsState, (state) => state.total);

export const selectLogsPage = createSelector(selectLogsState, (state) => state.page);

export const selectLogsPageSize = createSelector(selectLogsState, (state) => state.page_size);

export const selectLogsByLevel = (level: string) =>
  createSelector(selectAllLogs, (logs) => logs.filter((log) => log.level === level));
